export default function CourseController() {

}